module.exports = __webpack_public_path__ + "assets/img/block-51591399.png";